import "./App.css";
import React, { Component, useEffect, useState } from "react";
import Home from "./component/Home";
import Footer from "./component/Footer";
import { BrowserRouter, Link, Routes, Route, Navigate } from "react-router-dom";
import About from "./component/About";
import Contact from "./component/Contact";
import Vip from "./component/Vip";
import Number from "./component/Number";
import OfferZone from "./component/OfferZone.js";
import OrderStatus from "./component/OrderStatus";
import SignIn from "./component/auth/SIgnIn";
import Registration from "./component/auth/Registration";
import ForgotPassword from "./component/auth/ForgotPassword";
import apiCall from "./utils/apiCall";
import { initializeGuestSession } from "./utils/guestSessionUtils";
import GuestSessionDebug from "./component/common/GuestSessionDebug";
import { connect } from "react-redux";
import { activeUser } from "./component/common/redux/actions";
import "react-toastify/dist/ReactToastify.css";
import "./Vip.css";
import Cart from "./component/Cart";
import Orders from "./component/Orders";
import Checkout from "./component/Checkout";
import RefundPolicy from "./component/RefundPolicy";
import ShippingPolicy from "./component/ShippingPolicy";
import PrivacyPolicy from "./component/PrivacyPolicy";
import Blogs from "./component/Blogs.js";
import BlogDetails from "./component/BlogDetails.js";
import Faq from "./component/Faq.js";
import { jwtDecode } from "jwt-decode";
import TermsAndConditions from "./component/TermsAndConditions";
import VerifyEmail from "./component/VerifyEmail";
import FamilyBusinessPack from "./component/FamilyBusinessPack";

let mountLimit = 1;

const renderRoutes = (propsState) => {
  let activeUser = propsState.activeUser;
  let currentUser = activeUser.currentUser;
  let isUserVerified = activeUser.isUserVerified;
  let isGuest = !currentUser || currentUser?.isGuest;

  console.log("Router.js::renderRoutes::propsState", propsState);
  console.log("Router.js::renderRoutes::currentUser", currentUser);
  console.log("Router.js::renderRoutes::isUserVerified", isUserVerified);
  console.log("Router.js::renderRoutes::isGuest", isGuest);

  return (
    <React.Fragment>
      <Routes>
        <Route path="/*" element={<Navigate to="/" />}></Route>

        <Route path="/home" element={<Navigate to="/" />}></Route>

        <Route path="/" element={<Home />}></Route>

        <Route path="/vip" element={<Vip />}></Route>

        <Route path="/numbers" element={<Number />}></Route>
        <Route path="/offerzone" element={<OfferZone />}></Route>

        <Route path="/aboutUs" element={<About />}></Route>

        <Route path="/contactUs" element={<Contact />}></Route>

        <Route path="/RefundPolicy" element={<RefundPolicy />}></Route>

        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />}></Route>
        <Route path="/blogs" element={<Blogs />}></Route>
        <Route path="/blogs/:id" element={<BlogDetails />}></Route>
        <Route path="/Faq" element={<Faq />}></Route>
        <Route path="/ShippingPolicy" element={<ShippingPolicy />}></Route>

        <Route
          path="/TermsAndConditions"
          element={<TermsAndConditions />}
        ></Route>

        <Route
          path="/login"
          // component = {({match, location}) => {
          //     isUserVerified ? <Navigate to="/home"/>: <SignIn match={match} location={location} />
          // }}
          element={isGuest ? <SignIn /> : <Navigate to="/home" />}
        ></Route>

        <Route
          path="/signUp"
          element={isGuest ? <Registration /> : <Navigate to="/home" />}
        ></Route>
        <Route
          path="/forgotPassword"
          element={isGuest ? <ForgotPassword /> : <Navigate to="/home" />}
        ></Route>

        {/* <Route
          path="/verifyEmail*"
          element={isUserVerified ? <Navigate to="/home" /> : <VerifyEmail />}
        ></Route> */}

        <Route path="/orders" element={<Orders />}></Route>

        <Route path="/cart" element={<Cart />}></Route>

        <Route path="/cart*" element={<Cart />}></Route>

        <Route path="/family-business-pack" element={<FamilyBusinessPack />} />

        <Route path="/checkout" element={<Checkout />}></Route>

        <Route path="/checkout*" element={<Checkout />}></Route>

        <Route path="/orderStatus*" element={<OrderStatus />}></Route>
      </Routes>
    </React.Fragment>
  );
};

const Routers = (props) => {
  const [RouteGen, setRouteGen] = useState();
  const [showDebug, setShowDebug] = useState(false);

  const fetchUser = async () => {
    const { result } = await apiCall("REACT_APP_CURRENT_USER_URL", "GET");
    // const cData = await apiHelper('currentUser', 'get');
    if (result && result.success && result.user) {
      // localStorage.setItem('token', token);
      props.activeUser({
        isUserVerified: true,
        currentUser: result.user,
      });
    } else {
      props.activeUser({
        isUserVerified: false,
        currentUser: {},
      });
    }
  };

  const checkTokenExpiration = () => {
    const token = localStorage.getItem("token");

    if (token) {
      try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000; // Convert to seconds

        if (decoded.exp < currentTime) {
          console.log("Token expired. Logging out...");
          logoutUser();
        }
      } catch (error) {
        console.error("Invalid token", error);
        logoutUser();
      }
    }
  };

  const logoutUser = () => {
    localStorage.removeItem("token");
    <Navigate to="/home" />; // Redirect to login page
  };

  useEffect(() => {
    if (mountLimit == 1) {
      mountLimit++;

      fetchUser();
      checkTokenExpiration();
      
      // Initialize guest session early for guest users
      const initializeSession = async () => {
        try {
          await initializeGuestSession();
        } catch (error) {
          console.warn('Failed to initialize guest session:', error);
        }
      };
      
      // Only initialize guest session if user is not logged in
      if (!localStorage.getItem('token')) {
        initializeSession();
      }
      
      // Add keyboard shortcut for debug panel
      const handleKeyPress = (event) => {
        if (event.key === 'F12') {
          event.preventDefault();
          setShowDebug(prev => !prev);
        }
      };
      
      document.addEventListener('keydown', handleKeyPress);
      
      setTimeout(() => {
        mountLimit = 1;
      }, 500);
      
      return () => {
        document.removeEventListener('keydown', handleKeyPress);
      };
    }
    // if (window.location !== window.parent.location) {
    //   window.addEventListener(
    //     'message',
    //     event => {
    //       const eventData = event.data || {};
    //       console.log('eventData', eventData);
    //       if (eventData) {
    //         if (eventData.type && eventData.type === 'token') {
    //           const token = eventData.data.token;
    //           localStorage.setItem('token', token);
    //         }
    //       }
    //     },
    //     false
    //   );
    // }

    return () => {};
  });

  return (
    <React.Fragment>
      {renderRoutes(props.state)}
      <GuestSessionDebug show={showDebug} />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return { state };
};

// const mapDispatchToProps = {
//   activeUser
// };

export default connect(mapStateToProps, { activeUser })(Routers);
